import type { StickMixAndMatchResponse, StickResponse } from "../SticksMatrix";

import type { ProductDetailsProductData } from "./AemData.type";
import type { ProductGalleryAsset } from "./ProductGalleryAsset.type";

export type Category = {
  name: string;
  id: number;
};

export type MediaGalleryItem = Omit<ProductGalleryAsset, "path"> & {
  url: string;
};

export type SticksMultiPackProduct = {
  sku: string;
  name: string;
  label: string;
  description: string;
};

export type ProductDetailsStickSingleFlavor = StickResponse & { product: ProductDetailsProductData };
export type ProductDetailsStickMixAndMatch = StickMixAndMatchResponse & { product: ProductDetailsProductData };

export type ProductDetailsStick = ProductDetailsStickSingleFlavor | ProductDetailsStickMixAndMatch;

export type StickItem = {
  onetime: ProductDetailsStick[];
  subscription: ProductDetailsStick[];
};

export type StickItemMixAndMatch = {
  onetime: ProductDetailsStickMixAndMatch[];
  subscription: ProductDetailsStickMixAndMatch[];
};

export type ProductDetailsSticksData = {
  single_packs: StickItem;
  cartons: StickItem;
  mix_n_match: StickItemMixAndMatch;
};

export type OrderFrequency = "onetime" | "subscription";
export type PackagingPreference = "single_packs" | "cartons" | "mix_n_match";

export type ProductConfiguration = {
  packaging: PackagingPreference;
  frequency: OrderFrequency;
  flavour?: string;
};

export type ProductConfigurationOption = {
  sku: string | undefined;
};

export type ProductConfigurationOptions = {
  current: {
    frequency: OrderFrequency;
    packagingFormat: PackagingPreference;
  };
  available: {
    frequency: {
      onetime: ProductConfigurationOption;
      subscription: ProductConfigurationOption;
    };
    packagingFormat: {
      single_packs: ProductConfigurationOption;
      cartons: ProductConfigurationOption;
      mix_n_match: ProductConfigurationOption;
    };
  };
};
